module.exports = __webpack_public_path__ + "assets/404.7e10733e.svg";